import * as Bibliography from './Bibliography';
import * as Conferences from './Conferences';
import * as Global from './Global';
import * as OurTeam from './OurTeam';
import * as Publications from './Publications';
import * as Translations from './Translations';
import * as Travels from './Travels';


export default {
    Bibliography,
    Conferences,
    Global,
    OurTeam,
    Publications,
    Translations,
    Travels
}


// WEBPACK FOOTER //
// ./src/modules/index.js